import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { ApiUrlInjectionToken } from '@mitsubishi/shared/data-access';

import { MoveChildRequest } from '../models';

@Injectable({
  providedIn: 'root',
})
export class AlternativeService {
  private readonly baseUrl: string;

  constructor(
    private http: HttpClient,
    @Inject(ApiUrlInjectionToken) apiServerUrl: string
  ) {
    this.baseUrl = apiServerUrl + '/project';
  }

  createAlternative(projectId: string, selectionId: string): Observable<{ uuid: string }> {
    return this.http.post<{ uuid: string }>(`${this.baseUrl}/${projectId}/selection/${selectionId}/alternative`, {});
  }

  deleteAlternative(projectId: string, selectionId: string, alternativeId: string): Observable<null> {
    return this.http.delete<null>(`${this.baseUrl}/${projectId}/selection/${selectionId}/alternative/${alternativeId}`);
  }

  toggleFuturePricelist(projectId: string, selectionId: string, unitId: string): Observable<null> {
    return this.http.put<null>(
      `${this.baseUrl}/${projectId}/selection/${selectionId}/unit/${unitId}/toggle-future-pricelist`,
      {}
    );
  }

  updatePriceForCustomer(
    projectId: string,
    selectionId: string,
    alternativeId: string,
    priceForCustomer: number | null | undefined
  ): Observable<null> {
    return this.http.put<null>(
      `${this.baseUrl}/${projectId}/selection/${selectionId}/alternative/${alternativeId}/priceForCustomer`,
      { priceForCustomer }
    );
  }

  moveAlternativeRow(
    projectId: string,
    selectionId: string,
    alternativeId: string,
    moveChildRequest: MoveChildRequest
  ): Observable<null> {
    return this.http.post<null>(
      `${this.baseUrl}/${projectId}/selection/${selectionId}/alternative/${alternativeId}/move-child`,
      moveChildRequest
    );
  }

  confirmQuoteAlternative(projectId: string, selectionId: string, alternativeId: string): Observable<null> {
    return this.http.put<null>(`${this.baseUrl}/${projectId}/selection/${selectionId}/select/${alternativeId}`, {});
  }
}
